import SetUpError from 'features/payLater/screens/SetUpError/SetUpError';

export default function Page() {
  return <SetUpError />;
}
